import React from "react";

import ProfileSettings from "./ProfileSettings";

const Settings = () => {
  return <ProfileSettings />;
};

export default Settings;
